var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "form-group mb-2" }, [
        _c("small", { staticClass: "input-title" }, [
          _vm._v(
            _vm._s(_vm.data.package.type ? _vm.data.package.type : "Tipo")
          ),
        ]),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "form-control form-control-sm text-muted bg-white" },
          [
            _c(
              "router-link",
              {
                staticClass: "text-decoration-none",
                attrs: {
                  to: { name: "PackageDetail", params: { id: _vm.id } },
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s("" + _vm.data.package.type + _vm.id) +
                    "\n                    "
                ),
                _c("i", { staticClass: "fa-solid fa-square-arrow-up-right" }),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-6" }, [
      _c("small", { staticClass: "input-title" }, [_vm._v("Peso")]),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "form-control form-control-sm text-muted bg-white" },
        [
          _vm._v(
            "\n            " +
              _vm._s(Number(String(_vm.data.package.weight)).toFixed(2)) +
              "\n        "
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-12" }),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-6" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c("small", { staticClass: "input-title" }, [_vm._v("Impuesto")]),
          _vm._v(" "),
          _c("search-tax", {
            attrs: { tax: _vm.data.tax },
            model: {
              value: _vm.data.tax_id,
              callback: function ($$v) {
                _vm.$set(_vm.data, "tax_id", $$v)
              },
              expression: "data.tax_id",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-6" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c("small", { staticClass: "input-title" }, [_vm._v("Cliente")]),
          _vm._v(" "),
          _c("search-user", {
            on: {
              set_value: function (e) {
                return (_vm.data.user_id = e)
              },
            },
            model: {
              value: _vm.data.user,
              callback: function ($$v) {
                _vm.$set(_vm.data, "user", $$v)
              },
              expression: "data.user",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "form-group mb-2" }, [
        _c("small", { staticClass: "input-title" }, [_vm._v("Valor")]),
        _vm._v(" "),
        _c("div", { staticClass: "input-group input-group-sm mb-2" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.data.value,
                expression: "data.value",
              },
            ],
            staticClass: "form-control form-control-sm",
            attrs: { type: "text", placeholder: "0.00" },
            domProps: { value: _vm.data.value },
            on: {
              keypress: _vm.DOUBLE,
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.data, "value", $event.target.value)
              },
            },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-3" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c(
            "v-tooltip",
            {
              attrs: { top: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function (ref) {
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _c(
                        "button",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "btn btn-primary btn-h w-100",
                              attrs: {
                                type: "button",
                                disabled: !_vm.data.value || !_vm.data.tax_id,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.CALCULATE()
                                },
                              },
                            },
                            "button",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _vm.calculate == 1
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "spinner-border spinner-border-sm",
                                  attrs: { role: "status" },
                                },
                                [
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Loading..."),
                                  ]),
                                ]
                              )
                            : _c("span", [
                                _c("i", { staticClass: "bi bi-calculator" }),
                              ]),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            },
            [_vm._v(" "), _c("small", [_vm._v("Calcular")])]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-12" }, [
      _c(
        "div",
        { staticClass: "form-group mb-3" },
        [
          _c("small", { staticClass: "input-title" }, [_vm._v("Precio")]),
          _vm._v(" "),
          _c("div", { staticClass: "input-group input-group-sm mb-2" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.data.subtotal,
                  expression: "data.subtotal",
                },
              ],
              staticClass: "form-control form-control-sm",
              attrs: { type: "text", placeholder: "0.00" },
              domProps: { value: _vm.data.subtotal },
              on: {
                keypress: _vm.DOUBLE,
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.data, "subtotal", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group-append" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-success btn-m",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.ADD_LINE()
                    },
                  },
                },
                [_c("i", { staticClass: "bi bi-plus" })]
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm._l(_vm.data.invoice_items, function (bill, i) {
            return _c("div", { key: i, staticClass: "row mb-2" }, [
              _c(
                "div",
                { staticClass: "input-group input-group-sm col pl-0" },
                [
                  _vm._m(2, true),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: bill.value,
                        expression: "bill.value",
                      },
                    ],
                    staticClass: "form-control form-control-sm",
                    attrs: { type: "text", placeholder: "0.00" },
                    domProps: { value: bill.value },
                    on: {
                      keypress: _vm.DOUBLE,
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(bill, "value", $event.target.value)
                      },
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group input-group-sm col pr-0" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: bill.description,
                        expression: "bill.description",
                      },
                    ],
                    staticClass: "form-control form-control-sm",
                    attrs: { type: "text", placeholder: "Descripción" },
                    domProps: { value: bill.description },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(bill, "description", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger btn-m",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.REMOVE_LINE(i)
                          },
                        },
                      },
                      [_c("i", { staticClass: "bi bi-x" })]
                    ),
                  ]),
                ]
              ),
            ])
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-12" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c(
            "v-tooltip",
            {
              attrs: { top: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function (ref) {
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _c(
                        "button",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "btn btn-success btn-h w-100",
                              attrs: {
                                disabled: !_vm.data.subtotal,
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.CONFIRM()
                                },
                              },
                            },
                            "button",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _vm.confirm == 1
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "spinner-border spinner-border-sm",
                                  attrs: { role: "status" },
                                },
                                [
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Loading..."),
                                  ]),
                                ]
                              )
                            : _c("span", [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v("+ "),
                                _c("i", { staticClass: "bi bi-check-lg" }),
                              ]),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            },
            [_vm._v(" "), _c("small", [_vm._v("Confirmar")])]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "bi bi-currency-dollar" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "bi bi-currency-dollar" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "bi bi-currency-dollar" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }